import { render } from "./FixtureDetails.vue?vue&type=template&id=45d6bb25&scoped=true"
import script from "./FixtureDetails.vue?vue&type=script&lang=js"
export * from "./FixtureDetails.vue?vue&type=script&lang=js"

import "./FixtureDetails.vue?vue&type=style&index=0&id=45d6bb25&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d6bb25"]])

export default __exports__